const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
import downloadPDF from "@/mixins/downloadPDF";
import leaveRequests from '../../services/leaveRequest'
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
import { orderBy } from 'lodash';
import moment from 'moment-timezone'
import terminology from "@/mixins/terminology";
import { KEYWORDS } from "../../constants/support";
import { LEAVE_REQUEST_STATUSES } from "../../constants/variables";
import date from "../../mixins/date";
moment.tz.setDefault('Europe/Paris')

export default {
  components: {
    SectionTitle,
  },
  computed: {
    ...mapGetters({
      leaveRequestsTypes: "leaveRequestsTypes",
      leaveRequestsStatus: "leaveRequestsStatus",
      leaveRequestStatuses: "leaveRequestStatuses",
      getLeaveRequestSelected: "getLeaveRequestSelected",

    }),
    leaveRequests() {
      return this.leaveRequestsList.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  
  },
  mixins: [downloadPDF, terminology, date],
  async created() {
    try {
    if (!this.leaveRequestStatuses.length) {
      this.getLeaveRequestStatuses();
    }
    if(!this.leaveRequestsTypes.length) {
     await this.fetchLeaveRequestType()
   }
    await this.fetchListLeaveRequests()

    } catch(error){}
    finally {
      this.isLoading = false;
    }
  },
  data() {
    return {
      options: [],
      dateStartPicker: null,
      dateEndPicker: null,
      selected: null,
      isLoading: true,
      leaveRequestsList: [],
      currentPage: 1,
      perPage: 5,
      fields: [
        {
          key: 'pkIxLeaveStatut',
          label: this.$t('expense-view-status-label'),
        }, {
          key: 'startDate',
          label: this.$t('start'),
        }, {
          key: 'endDate',
          label: this.$t('my-schedule-end-time'),
        }, {
          key: 'pkIxLeaveType',
          label: this.$t('type-of-leave'),
        }
      ],
      keyword: KEYWORDS.DEF_CONGES
    }
  },
  methods: {
    ...mapActions(['getLeaveRequestStatuses', 'fetchLeaveRequestType']),
    editable(row) {
      const editableStatuses = [LEAVE_REQUEST_STATUSES.WAIT_FOR_VALIDATION];
      return row && editableStatuses.includes(row.pkIxLeaveStatut)
    },
    renderType(typeId) {

      if(this.leaveRequestsList &&  Number(typeId)) {
        const result = this.leaveRequestsTypes.find((item) => item.value === Number(typeId));
        if(result && result.text) {
          return result.text
        }
        return '';
      }

      return;
     
    },
    renderHour(dateFin, dateDebut) {
      if (!dateFin || !dateDebut) return 0 + ' jours'
      const end = new moment(dateFin)
      const start = new moment(dateDebut)
      const duration = moment.duration(end.diff(start))
      return Math.floor((duration.asDays() + 1)) * 8 + ' jours'
    },
    async fetchListLeaveRequests() {
      try {
        const { data } = await leaveRequests.getListLeaveRequests()
        if(data) {
          this.leaveRequestsList = orderBy(data.map((item) => {
            this.$set(item, 'durée', this.renderHour(item.dateFin, item.dateDebut))
            return item
          }), ['startDate', 'endDate', 'creationDate'], ['desc', 'desc', 'desc'])
        } 
        }
        catch (error) {
      } finally {
        this.isLoading = false
      }
    },
    onRowClicked(row) {
      this.$store.commit('LEAVE_REQUEST_SELECTED', row)
   
      this.$router.push({
        name: this.editable(row) ? `employee-leave-form-edit`: `employee-leave-detail`,
        params: { type: 'edit', id: row.pkLeaveRequest },
      })
    }
  },
};
